@if (!!subscription && show) {
  <div class="container">
    <div class="row">
      <div class="col-sm-4 label">Report Type</div>
      <div class="col-sm-8 value">
        {{ subscription.reportNameDisplay.text }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 label">Created</div>
      <div class="col-sm-8 value">
        {{ subscription.created | date: "MM/dd/yyyy" }}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 label">Supplier</div>
      <div class="col-sm-8 value">{{ subscription.supplierName }}</div>
    </div>
    @if (shouldHideFilter()) {
      <kehe-phoenix-loading></kehe-phoenix-loading>
    }
    @if (!shouldHideFilter()) {
      @for (filterItem of subscription.filter; track filterItem) {
        <div class="row">
          <div class="col-sm-4 label">{{ createLabelName(filterItem) }}</div>
          <div class="col-sm-8 value">
            {{ transformFilterValues(filterItem) }}
            <div>
              @if (
                !filterItem.expanded &&
                filterItem.value.length > numFilterValuesForPreview
              ) {
                <a
                  class="more-link"
                  (click)="filterItem.expanded = !filterItem.expanded"
                >
                  {{
                    "+" +
                      (filterItem.value.length - numFilterValuesForPreview) +
                      " More"
                  }}
                </a>
              }
            </div>
          </div>
        </div>
      }
    }
    <hr />
    <div class="row">
      <div class="col-sm-12">
        <h4>Recurrence</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 label">Frequency</div>
      <div class="col-sm-8 value">{{ subscription.recurrence }}</div>
    </div>
    @if (subscription.recurrence === "Weekly") {
      <div class="row">
        <div class="col-sm-4 label">Days</div>
        <div class="col-sm-8 value">{{ subscription.daysView }}</div>
      </div>
    }
  </div>
}
